let pictureFileType = [
  'png', 'jpg'
]
let videoFileType = [
  'mp4'
]


export { pictureFileType, videoFileType }